import React, { Component } from "react";
import styled from 'styled-components';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { getFavoritosRef, addFavoritesRef, getMessagesFavoritesServices } from '../../../store/actions/favoritosRef.js';
import { executeTaggeo } from "../../../store/actions";
import { getTagServiceId, getMessageFavServices, getListFavsServices } from '../../../store/selectors/paymentsSelectors'
import { ClaroModalCustom, ClaroCardSimple, ClaroModalCardOk } from "@claropay/shared";
import ClaroButton from "../../atoms/ClaroButton";
import FavoriteElement from '../../atoms/FavoriteElement/';
import ModalCardLoader from "../ModalCardLoader/index.js";
import ClaroInputField from "../../atoms/ClaroInputField";
import InputTitleClaroSocio from '../../molecules/InputTitleClaroSocio';
import ToolTipMiTelcel from '../../organisms/TooltipMiTelcel';
import { getMessage } from "../../organisms/utils.js";
import ModalCardOk from "../ModalCardOk";
import ClaroImage from '../../molecules/ClaroImage';
import { validateUserAgent } from "../../organisms/utils.js";

const ContainerListFavs = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  overflow: hidden;
`
const ButtonClose = styled.button`
  position: absolute;
  top: 0;
  right: 0;
  border: 0;
  background-color: transparent;
`
const LogoServiceFavs = styled.img`
  margin-top: 16px;
  margin-bottom: 24px;
`
const SubtitleServiceFavs = styled.h2`
  font-size: 14px !important;
  font-family: Roboto;
  color: #848484;
  text-align: left;
  align-self: flex-start;
  margin-bottom: 16px;
  `
  const containerAliasStyles = {
    padding: '0 16px', 
    width:'100%'
};

const containerReferenceStyles = {
    padding: '16px', 
    marginBottom:'16px',
    width:'100%'
};

const p = styled.p`
  color: 'black', fontSize: '12px', textAlign: 'left'`


class CreateFavoriteService extends Component {
    constructor(props) {
        super(props);
        this.state = {
            alias: '',
            modal: false,
            codigo:'',
            disabledButton:true,
        };
    }

    componentDidMount() {
        const {getMessagesFavoritesServices,alias,tagServiceId,executeTaggeo} = this.props
        getMessagesFavoritesServices('PagoServicios');
        if(alias){
            this.setState({ alias: alias })
        }

        executeTaggeo({
            action: "View",
            step: "Formulario de referencia",
            service: tagServiceId,
          });
    }

    componentDidUpdate(prevState) {
        if(this.state.codigo === '' && this.state.modal && !this.props.isLoadingGetFavServices && !this.props.listFavServices){          
           this.handleChangeCodigoModals();
        }   
    }


    handleChangeCodigoModals = () =>{
        const {lidFavorite,hasFavsError,executeTaggeo,tagServiceId,listMessagesFavServices,errorCodeFavs} = this.props
        if(!lidFavorite){
            if(!hasFavsError){
                this.setState({codigo:'CP0528'})
                executeTaggeo({
                    action: "View confirmation",
                    step: "Formulario de pago",
                    confirmation_id: "Servicio Guardado",
                    service: 
                    tagServiceId,
                })
            }else{
                this.setState({codigo:errorCodeFavs})
             this.setState({messageInformation:getMessage(listMessagesFavServices,errorCodeFavs )}) 
             executeTaggeo({
                action: "View alert",
                step: "Formulario de pago",
                alert_id: "Imposible consultar guardados",
                service: tagServiceId,
            })
                 
            } 
        }else{
            if(!hasFavsError){
                executeTaggeo({
                    action: "View confirmation",
                    step: "Formulario de pago",
                    confirmation_id: "Guardado editado con éxito",
                    service: tagServiceId,
                })
                this.setState({codigo:'CP0522'})
                this.setState({messageInformation:getMessage(listMessagesFavServices,'CP0522' )})
            }else{
                executeTaggeo({
                    action: "View alert",
                    step: "Formulario de pago",
                    alert_id: "Guardado editado sin éxito",
                    service: tagServiceId,
                })
                this.setState({codigo:errorCodeFavs})
                this.setState({messageInformation:getMessage(listMessagesFavServices,errorCodeFavs)})
            }
        }
    }

    saveFavorites = () => {
        const {lidFavorite,accountService,executeTaggeo,tagServiceId,addFavoritesRef} = this.props
        const contact = {
            accountService: accountService, alias: this.state.alias, lidFavorite: lidFavorite
        }
            executeTaggeo({
                action: "Click Guardar",
                step: "Formulario de referencia",
                service: this.props.tagServiceId,
            })
    
        addFavoritesRef(contact,tagServiceId); 
        this.setState({ modal: true }) 
    }

    handleInputChange = (event) => {
        let newValue = event.target.value.substr(0, 30);
        newValue = newValue.replace(/\p{Extended_Pictographic}/u, "");
        this.setState({ alias: newValue })
        if (event.target.value === '' || event.target.value === this.props.alias) {
            this.setState({ disabledButton: true });
        } else {
            this.setState({ disabledButton: false });
        }
        
       
    }

    handleEditCloseModal = () => {
        const {executeTaggeo,tagServiceId,closeModalFavoriteServices} = this.props;
        if(this.state.codigo === "CP0521"){
            executeTaggeo({
              action: "Click alert Entendido",
              step: "Formulario de pago",
              alert_id: "Guardado editado sin éxito",
              service: tagServiceId,
            });
          }else if(this.state.codigo === "CP0522"){
            executeTaggeo({
              action: "Click Entendido",
              step: "Formulario de pago",
              confirmation_id: "Guardado editado con éxito",
              service: tagServiceId,
            });
          }
        this.setState({ modal: false })
        closeModalFavoriteServices()
    }

    render() {
        const { closeModalFavoriteServices,isLoadingGetFavServices, isFavoriteServices, isContainerTelcel, mediaService,lidFavorite,hasFavsError,executeTaggeo,tagServiceId,listMessagesFavServices,accountService,logoService } = this.props;
        const {modal,alias,disabledButton,messageInformation,codigo} = this.state
        const textReference = mediaService.find(ele => ele.id === 'buttonBox').cp.find(ele => ele.id === 'favoritos').textRef;

        if (isLoadingGetFavServices) {
            return (
                <ModalCardLoader isOpen={isLoadingGetFavServices} />
            )
        } else {
            return (
                <>
                    {!modal && (
                        <ClaroModalCustom isOpen={isFavoriteServices} backgroundColor={'rgba(0, 0, 0, 0.65)'}>
                            <ClaroCardSimple
                                backgroundColor='#ffffff'
                                borderRadius={lidFavorite ? '8px' : '20px 20px 0px 0px'}
                                margin={lidFavorite ? '0px 16px ' : '0 0 -70% 0'}
                                height={lidFavorite ? 'auto' : '100%'}
                                width={lidFavorite ? 'auto' : '100%'}
                                fadeIn={lidFavorite ? '' : 'fadeIn'}
                                fadeInTime={lidFavorite ? '' : '1s'}
                                cubicBezier={lidFavorite ? '' : 'cubic-bezier(0.9, 0, 0.9, 1)'}
                                padding='20px 16px 32px 16px'
                                addCloseEfect={false}
                            >
                                <ContainerListFavs>
                                    <ButtonClose 
                                    onClick={()=>{
                                        closeModalFavoriteServices();
                                    }}
                                    >
                                        <img
                                            src={isContainerTelcel ? "/images/icono_salir_contenedor.png" : "/images/icono_salir.svg"}
                                            width={isContainerTelcel ? "24" : "16"}
                                            height={isContainerTelcel ? "24" : "16"}
                                        />
                                    </ButtonClose>
                                    {tagServiceId !== 'amigopaguitos' &&(
                                        <ClaroImage {...logoService}/>
                                    )
                                        }
                                    
                                    {tagServiceId === 'amigopaguitos' &&(<LogoServiceFavs
                                        src={this.props.configImgService}
                                        width="45%"
                                        height="auto"
                                        alt=""
                                    /> )}
                                    <SubtitleServiceFavs>Guardar Servicio</SubtitleServiceFavs>
                                    <div style={containerAliasStyles}>
                                    <InputTitleClaroSocio
                                        text="Alias:"
                                        titleStyle={{
                                            background: "transparent"
                                        }}
                                    />
                                    <ClaroInputField
                                        onChange={this.handleInputChange}
                                        placeholder="Ingresa un alias para tu servicio"
                                        value={alias}
                                        width="100%"
                                        maxLength="30"
                                        />
                                    </div>
                                    <div style={containerReferenceStyles}>
                                    <InputTitleClaroSocio
                                        text={textReference}
                                        titleStyle={{
                                            background: "transparent",
                                            color: "rgb(70, 80, 90)",
                                        }}
                                    />

                                    <p style={{ color: '#474747', fontSize: '14px', width: '100%', marginTop: "4px" }}>{accountService}</p>
                                    </div>
                                    
                                    <ClaroButton
                                        disabled={disabledButton}
                                        favoritos={true}
                                        backgroundColor='#000'
                                        activeBackgroundButton='none'
                                        hoverBackgroundButton='none'
                                        color='#fff'
                                        fontFamily='RobotoBold'
                                        fontWeight='700'
                                        fontSize='4.05vw !important'
                                        lineHeight="normal!important"
                                        borderRadius='50px'
                                        width='61.111vw'
                                        height='11.4667vw'
                                        margin='0 auto'
                                        display='block'
                                        onClick={()=>{
                                            this.saveFavorites();
                                        }}
                                    >
                                        Guardar
                                    </ClaroButton>
                                </ContainerListFavs>
                            </ClaroCardSimple>
                        </ClaroModalCustom>
                    )}
                    <>
                        {modal && codigo !== '' && (

                            <div style={{ position: 'absolute', top: '0', left: '0', width: '100%', height: '100%' }}>
                                {!lidFavorite && (
                                    <>
                                    {!hasFavsError && (
                                    <ToolTipMiTelcel
                                        tooltipInformation={getMessage(listMessagesFavServices, codigo)}
                                        isOpen={modal}
                                        handleNextAction={
                                            () => {
                                                executeTaggeo({
                                                    action: "Click confirmation Entendido",
                                                    step: "Formulario de pago",
                                                    confirmation_id: "Servicio Guardado",
                                                    service: tagServiceId,
                                                })
                                                this.setState({ modal: false })
                                                closeModalFavoriteServices()
                                            }
                                        }
                                    />
                                    )}
                                    {hasFavsError && (
                                    <ModalCardOk
                                        isOpen={modal}
                                        srcImage={messageInformation.data.icon}
                                        text={messageInformation.data.subject}
                                        textdetail={messageInformation.data.message}
                                        buttontext={messageInformation.data.buttons}
                                        onclickModal={() => {
                                            executeTaggeo({
                                                action: "Click alert Entendido",
                                                step: "Formulario de pago",
                                                alert_id: "Imposible consultar guardados",
                                                service: tagServiceId,
                                            })
                                            this.setState({ modal: false })
                                            closeModalFavoriteServices()
                                        }}
                                        fontSizeTitle={validateUserAgent() === 'android' ? '22px' : '18px'}
                                        fontFamilyTitle={"NunitoBold"}
                                        fontSizeDetail={validateUserAgent() === 'android' ? '18px' : '14px'}
                                        fontSizeButton={validateUserAgent() === 'android' ? '16px' : '14px'}
                                    />
                                    )}
                                    </>
                                )}
                                {lidFavorite && (
                                    <ModalCardOk
                                        isOpen={modal}
                                        srcImage={messageInformation.data.icon}
                                        text={messageInformation.data.subject}
                                        textdetail={messageInformation.data.message}
                                        buttontext={messageInformation.data.buttons}
                                        onclickModal={() => {
                                            this.handleEditCloseModal()
                                        }}
                                        fontSizeTitle={validateUserAgent() === 'android' ? '22px' : '18px'}
                                        fontFamilyTitle={"NunitoBold"}
                                        fontSizeDetail={validateUserAgent() === 'android' ? '18px' : '14px'}
                                        fontSizeButton={validateUserAgent() === 'android' ? '16px' : '14px'}
                                    />
                                )}
                            </div>

                        )}
                    </>



                </>
            )
        }
    }
}

function mapStateToProps(state) {
    const { payments, favoritesRefReducer } = state;
    const { messages } = payments
    const tagServiceId = getTagServiceId(payments);
    const listFavServices = getListFavsServices(favoritesRefReducer);
    const listMessagesFavServices = getMessageFavServices(favoritesRefReducer);
    return {
        favoriteServices: state,
        hasFavSucces:state.favoritesRefReducer.ResponseSuccess,
        hasFavsError: state.favoritesRefReducer.ResponseError,
        errorCodeFavs: state.favoritesRefReducer.CodeError,
        isLoadingGetFavServices: state.favoritesRefReducer.isLoading,
        tagServiceId: tagServiceId,
        listFavServices,
        messages: messages,
        listMessagesFavServices: listMessagesFavServices,
        logoService: state.payments.PAYMENT_SERVICE_CONF.services[0].serviceData.generic.logo.data,
        mediaService: state.payments.PAYMENT_SERVICE_CONF.services[0].serviceData.generic.elements,
    };
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators(
        {
            addFavoritesRef,
            getMessagesFavoritesServices,
            executeTaggeo,
        },
        dispatch
    );
}

export default connect(mapStateToProps, mapDispatchToProps)(CreateFavoriteService);